var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Work",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.158,
    height: 18.158,
    viewBox: "0 0 18.158 18.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Work-2",
    "data-name": "Work",
    d: "M3.606,18.158A3.477,3.477,0,0,1,.154,14.664L.091,9.975a.191.191,0,0,1,.082-.156A.116.116,0,0,1,.237,9.8a.188.188,0,0,1,.108.037A15.5,15.5,0,0,0,6.7,12.228a.656.656,0,0,0,.09.006.684.684,0,0,0,.655-.5,1.656,1.656,0,0,1,1.616-1.25h.028a1.656,1.656,0,0,1,1.616,1.25.684.684,0,0,0,.656.5.652.652,0,0,0,.089-.006,15.5,15.5,0,0,0,6.359-2.39l.036-.019a.166.166,0,0,1,.073-.017.12.12,0,0,1,.064.017.191.191,0,0,1,.082.156l-.073,4.689a3.477,3.477,0,0,1-3.451,3.493Zm4.787-5.672v1.186a.686.686,0,0,0,.681.689.678.678,0,0,0,.681-.689V12.485a.686.686,0,0,0-.681-.69A.694.694,0,0,0,8.393,12.485ZM11.665,10.6a3,3,0,0,0-2.59-1.5,3.049,3.049,0,0,0-2.608,1.491.3.3,0,0,1-.251.15.26.26,0,0,1-.051,0,14.094,14.094,0,0,1-5.1-2.059L.19,8.072a.262.262,0,0,1-.118-.221C.047,7.391,0,5.89,0,5.875a3.486,3.486,0,0,1,3.46-3.5H5.25A2.7,2.7,0,0,1,7.9,0h2.343A2.7,2.7,0,0,1,12.9,2.372h1.8a3.486,3.486,0,0,1,3.46,3.5c0,.008-.054.829-.073,1.955a.3.3,0,0,1-.117.232c-.427.315-.833.587-.873.607a13.916,13.916,0,0,1-5.127,2.077.275.275,0,0,1-.051,0A.3.3,0,0,1,11.665,10.6ZM6.631,2.372h4.887a1.314,1.314,0,0,0-1.271-.993H7.9A1.314,1.314,0,0,0,6.631,2.372Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/Work.0ba3b2ad71bedc42cd8cb0eeb15c9ffc.svg";
export { ForwardRef as ReactComponent };